<div class="list">
  @for (prediction of predictions; track $index) {
    <app-address-row (click)="selectAddress(prediction)" [structuredFormatting]="prediction.structured_formatting" />
  }
</div>